export default __webpack_public_path__ + "static/media/images.acb2ecc1.jpg";